import { useMutation } from '@tanstack/react-query';

import { createDeeplinkService } from '@/services/httpServices/GeneralServices';
import type { CreateDeeplinkServiceConfig } from '@/services/httpServices/GeneralServices/types';

export function useCreateDeeplinkMutation() {
  return useMutation({
    mutationFn: (params: CreateDeeplinkServiceConfig) => createDeeplinkService(params),
  });
}
